// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getScheduleList = createAsyncThunk(
    'scheduleNotification/getScheduleList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/schedule/get', { params })
        console.log("response", response)

        return {
            totalPages: response.data?.data?.length,
            params: response.data.params,
            data: response.data.data
        }
    }
)

export const getCampaignList =
    createAsyncThunk(
        'scheduleNotification/getCampaignList',
        async () => {

            const response =
                await axios.get(
                    baseUrl() +
                    '/schedule/list'
                )

            return {
                data: response.data.data
            }
        }
    )

export const startScheduler = createAsyncThunk(
    'scheduleNotification/startScheduler',
    async (audience, { dispatch }) => {

        try {

            await axios.post(
                baseUrl() +
                `/schedule/start/${audience}`
            )

            toast.success(
                `${audience} scheduler started`
            )

            dispatch(
                getCampaignList()
            )

        } catch (error) {

            toast.error(
                error?.response?.data?.message
            )
        }
    }
)

export const stopScheduler = createAsyncThunk(
    'scheduleNotification/stopScheduler',
    async (audience, { dispatch }) => {

        try {

            await axios.post(
                baseUrl() +
                `/schedule/stop/${audience}`
            )

            toast.success(
                `${audience} scheduler stopped`
            )

            dispatch(
                getCampaignList()
            )

        } catch (error) {

            toast.error(
                error?.response?.data?.message
            )
        }
    }
)


// export const startCampaign = createAsyncThunk(
//     'campaign/startCampaign',
//     async (id, { dispatch }) => {

//         try {

//             await axios.post(
//                 baseUrl() + `/schedule/start/${id}`
//             )

//             toast.success('Campaign Started')

//             dispatch(getCampaignList())

//         } catch (error) {

//             toast.error(
//                 error?.response?.data?.message
//             )
//         }
//     }
// )

// export const stopCampaign = createAsyncThunk(
//     'campaign/stopCampaign',
//     async (id, { dispatch }) => {

//         try {

//             await axios.post(
//                 baseUrl() + `/schedule/stop/${id}`
//             )

//             toast.success('Campaign Stopped')

//             dispatch(getCampaignList())

//         } catch (error) {

//             toast.error(
//                 error?.response?.data?.message
//             )
//         }
//     }
// )

// export const getCampaignStatus = createAsyncThunk(
//     'campaign/getCampaignStatus',
//     async (id) => {

//         const response = await axios.get(
//             baseUrl() + `/schedule/status/${id}`
//         )

//         return response.data.data
//     }
// )


// export const allBusinessList = createAsyncThunk(
//     'scheduleNotification/allBusinessList',
//     async (params) => {
//         const response = await axios.get(baseUrl() + '/banner', { params })
//         return {
//             params: response.data.params,
//             allBusinessList: response.data.result
//         }
//     }
// )

// export const createSchedule = createAsyncThunk(
//     'scheduleNotification/createSchedule',
//     async ({ payload, params }, { dispatch, getState }) => {

//         try {
//             await axios.post(baseUrl() + '/schedule/create', payload)
//             toast.success('Schedule Added successfully')
//             await dispatch(getScheduleList({ params: params }))
//             return true
//         } catch (error) {
//             toast.error(error?.response?.data?.message)
//             return false
//         }
//     }
// )

// export const updateSchedule = createAsyncThunk(
//     'scheduleNotification/updateSchedule',
//     async ({ id, payload }, { dispatch, getState }) => {

//         try {
//             await axios.put(baseUrl() + `/schedule/update/${id}`, payload)
//             toast.success('Schedule Updated successfully')
//             await dispatch(getScheduleList())
//             return true
//         } catch (error) {
//             toast.error(error?.response?.data?.message)
//             return false
//         }
//     }
// )

// export const cancelSchedule = createAsyncThunk(
//     'scheduleNotification/cancelSchedule',
//     async ({ id, isActive, params }, { dispatch }) => {
//         console.log("cancelSchedule", id, isActive, params)

//         try {
//             await axios.patch(baseUrl() + `/schedule/toggle/${id}`, {
//                 isActive: isActive
//             }),
//                 toast.success('Schedule stopped successfully')
//             await dispatch(getScheduleList(params))
//             return true
//         } catch (error) {
//             toast.error(error?.response?.data?.message)
//             return false
//         }
//     }
// )

// export const deleteSchedule = createAsyncThunk(
//     'scheduleNotification/deleteSchedule',
//     async ({ id }, { dispatch, getState }) => {
//         try {
//             await axios.delete(baseUrl() + `/schedule/delete/${id}`),
//                 toast.success('Schedule Deleted successfully')
//             await dispatch(getScheduleList())
//             return true
//         } catch (error) {
//             toast.error(error?.response?.data?.message)
//             return false
//         }
//     }
// )

export const scheduleNotification = createSlice({
    name: 'scheduleNotification',
    initialState: {
        scheduleList: [],
        campaignList: [],
        selectFacility: [],
        allBusinessList: [],
        campaignStatus: null,
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null
    },
    reducers: {
        selectScheduleNotification: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        }
    },

    extraReducers: {



        [getCampaignList.fulfilled]: (state, action) => {
            state.campaignList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },

        [startScheduler.fulfilled]: (
            state
        ) => {

            state.reload = !state.reload
            state.loader = false
        },

        [stopScheduler.fulfilled]: (
            state
        ) => {

            state.reload = !state.reload
            state.loader = false
        },

        // [getCampaignStatus.fulfilled]: (
        //     state,
        //     action
        // ) => {

        //     state.campaignStatus = action.payload
        // }

        // [createSchedule.fulfilled]: (state, action) => {
        //     state.reload = !state.reload
        // },
        // [getScheduleList.fulfilled]: (state, action) => {
        //     state.scheduleList = action.payload.data
        //     state.totalPages = action.payload.totalPages
        //     state.loader = false
        // },
        // [allBusinessList.fulfilled]: (state, action) => {
        //     state.allBusinessList = action.payload.allBusinessList
        // },
        // [updateSchedule.fulfilled]: (state, action) => {
        //     state.reload = !state.reload
        //     state.loader = false
        // },
    }
})

export const { selectScheduleNotification, setLoader, setRowsPerPage, setCurrentPage } = scheduleNotification.actions

export default scheduleNotification.reducer
